var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class FileNamePattern {
  constructor(_data) {
    /**
     */
    __publicField(this, "Example");
    /**
     */
    __publicField(this, "Pattern");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof FileNamePattern
     */
    __publicField(this, "$type", "V1.Cesop.Configuration.FileNamePattern");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Example = _data["Example"];
      this.Pattern = _data["Pattern"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Example"] = this.Example;
    _data["Pattern"] = this.Pattern;
    return _data;
  }
}
